/**
 * `/strona` — „Twoja strona i formularz leadowy", the trainer's public form builder.
 *
 * A wiring declaration. A top-level address since 28 September 2026: under `/klienci/…` the
 * Klienci navigation entry lit up together with the builder's own, and the page is a destination
 * of its own rather than part of the roster.
 */

import { createFileRoute } from '@tanstack/react-router';

import { PublicFormBuilderScreen } from '~/pages/public-form-builder';

export const Route = createFileRoute('/_shell/strona')({
  component: PublicFormBuilderScreen,
});
